import React, { Component } from 'react';

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Container, TextField, Typography, Box, Avatar, CssBaseline, Button } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

class ConfirmCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: '',
      newPassword: '',
      cofirmNewPassword: '',
    };
  }

  renderLogIn = () => {
    const { code, newPassword, cofirmNewPassword } = this.state;
    const { location, t } = this.props;
    const { state } = location;
    const confPassText = t('authScreenTranslations:CONF_PASS');
    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {state.isChangePassword ? t('authScreenTranslations:NEW_PASS') : confPassText}
          </Typography>

          <Box sx={{ mt: 1 }}>
            <Typography sx={{ mt: 2, mb: 2 }} textAlign="center">
              {t('authScreenTranslations:MSG1')}?{' '}
              {state.isChangePassword ? t('authScreenTranslations:CHANGE_PASS') : confPassText}
            </Typography>
            <TextField
              sx={{ mb: 2 }}
              margin="normal"
              fullWidth
              name="code"
              label={t('authScreenTranslations:CODE')}
              value={code}
              onChange={e => this.setState({ code: e.target.value })}
            />
            {state.isChangePassword ? (
              <>
                <TextField
                  sx={{ mb: 2 }}
                  margin="normal"
                  fullWidth
                  name="password"
                  label={t('authScreenTranslations:NEW_PASS')}
                  type="password"
                  value={newPassword}
                  onChange={e => this.setState({ newPassword: e.target.value })}
                />

                <TextField
                  sx={{ mb: 2 }}
                  margin="normal"
                  fullWidth
                  name="confimpassword"
                  label={confPassText}
                  type="password"
                  value={cofirmNewPassword}
                  onChange={e => this.setState({ cofirmNewPassword: e.target.value })}
                />
              </>
            ) : null}

            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 1, mb: 2 }}
              onClick={() => this.props.history.push('/signin')}
            >
              {state.isChangePassword
                ? t('authScreenTranslations:CHANGE_PASS')
                : t('authScreenTranslations:CONF')}
            </Button>
          </Box>
        </Box>
      </Container>
    );
  };

  render() {
    const { location, auth } = this.props;
    const { loggedIn } = auth;

    return loggedIn ? (
      <Redirect to={{ pathname: '/', state: { from: location } }} />
    ) : (
      this.renderLogIn()
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

const cConfirmCode = connect(mapStateToProps, {})(ConfirmCode);
const tConfirmCode = withTranslation(['authScreenTranslations'])(cConfirmCode);

export { tConfirmCode as ConfirmCode };
